import { Heading } from '@cinch-labs/design-system'
import styles from './how-it-works.module.css'
import { IconCard } from '../icon-card'
import { StoryBlokHowCinchWorksListItem } from '../../types/store-page'
import { StoreCtaButton } from '../cta-button'
import { StoreType } from '@cinch-nx/landing-ui-shared'

export interface HowItWorksProps {
  title: string
  howCinchWorksList: StoryBlokHowCinchWorksListItem[]
  slug: string
  storeType: StoreType
}

export function HowItWorks({
  title,
  howCinchWorksList,
  slug,
  storeType,
}: HowItWorksProps) {
  return (
    <section className={styles.root}>
      <Heading className={styles.title}>{title}</Heading>
      <div className={styles.cardList}>
        {howCinchWorksList.map((listItem) => (
          <IconCard
            icon={listItem.icon}
            title={listItem.title}
            body={listItem.body}
            key={listItem.title}
          />
        ))}
      </div>
      {storeType !== StoreType.clickAndCollect && (
        <StoreCtaButton slug={slug} trackEventTitle="how it works" />
      )}
    </section>
  )
}
